module.exports = "/static/media/glyphicons-halflings-regular.f4769f9b.eot";